<div class="{{title ? 'title d-flex justify-content-between align-items-center mt-2' : ''}}">
    <div class="d-flex justify-content-between align-items-center" style="gap: 25px;">
        <h3 class="m-0" *ngIf="title">{{title}}</h3>
        <ng-content></ng-content>
    </div>

    <div class="ml-3">
        <div class="filter-list-container">
            <button *ngFor="let item of headerSelections; index as i" 
                class="btn btn-icon"
                [ngClass]="{ active: pageId == i+1 }"
                type="button"
                (click)="pageId = i+1; changePageNumber()">
                <span class="btn-inner--text"> {{item}} </span>
            </button>
        </div>
    </div>
</div>